import { browserTracingIntegration, init as sentryInit } from '@sentry/vue'
import type { App } from 'vue'
import type { Router } from 'vue-router'

export function setupSentry(app: App, router: Router) {
  if (import.meta.env.MODE !== 'development') {
    const env = import.meta.env.MODE
    sentryInit({
      app,
      dsn: 'https://8b0f9cc2ece92c91b885269159503cf0@sentrynew.shengpay.com/8',
      integrations: [
        browserTracingIntegration({ router }),
      ],
      sendDefaultPii: true,
      tracesSampleRate: env === 'production' ? 0.2 : 0.5,
      replaysSessionSampleRate: env === 'production' ? 0.01 : 0.1, // 生产环境1%，开发环境10%
      replaysOnErrorSampleRate: 1.0, // 错误时100%采样
      ignoreErrors: [
        'AxiosError: Network Error',
        'Cannot read properties of null (reading \'visibilityState\')',
        'Cannot read properties of null (reading \'createElement\')',
        'Cannot read properties of null (reading \'hidden\')'
      ],
      environment: env,
    })
  }
}
